var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDayImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 383,
    viewBox: "0 0 500 383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.516,
    y1: 0.93,
    x2: 0.512,
    y2: 0.269,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94c9ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "day_image",
    transform: "translate(-678 -214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M74,405V64a42,42,0,0,1,42-42H532a42,42,0,0,1,42,42V405Z",
    transform: "translate(604 192)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud2",
    transform: "translate(319 24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 161,
    height: 66,
    rx: 33,
    transform: "translate(461 301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 38,
    cy: 37.5,
    rx: 38,
    ry: 37.5,
    transform: "translate(466 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 38,
    cy: 37.5,
    rx: 38,
    ry: 37.5,
    transform: "translate(518 278)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud2-2",
    "data-name": "cloud2",
    transform: "translate(581 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 123,
    height: 50,
    rx: 25,
    transform: "translate(461 290)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5",
    cx: 29,
    cy: 28.5,
    rx: 29,
    ry: 28.5,
    transform: "translate(465 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6",
    cx: 29,
    cy: 28.5,
    rx: 29,
    ry: 28.5,
    transform: "translate(505 272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M52,164V39.241A41.536,41.536,0,0,1,87.555,69.606a41.54,41.54,0,0,1,55.476,22.451A36,36,0,0,1,141,164Z",
    transform: "translate(626 295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sun",
    transform: "translate(979 267)",
    fill: "#f8ff24",
    stroke: "#fffdbe",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 77.5,
    r: 77.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 77.5,
    r: 72.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayImage);
export default __webpack_public_path__ + "static/media/day_image.76ae98a791bd924e17ef888133374880.svg";
export { ForwardRef as ReactComponent };